import React ,{useContext,useEffect,useState}from 'react'
import "../App.css";
import { AuthContext } from "../Auth.js";
import firebase from 'firebase/compat';

function BlogData({blog_data,id}) {
    const { currentUser } = useContext(AuthContext);
    const [user, set_user] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
  
      const subscriber = firebase.firestore()
        .collection("users")
        .doc(currentUser.email)
        .onSnapshot(data => {
          set_user(data.data());
          setLoading(false);
        });
      return () => subscriber();
    }, [])


  
const add_to_fire = ()=>{
    firebase.firestore().collection("ack")
    .doc(user.email)
    .set({email:user.email,name:user.name,sta:id,img:user.avatar,timestamp:Date.now()},{merge:true})

    window.alert("You'are set to be interested...you may contact via us soon...")
}

  return (
    <div className='flex_row'>
        <div className="interested_button" onClick={()=>add_to_fire()}>
            <h2>{blog_data.title}</h2>
            <h2 className='exe_button'>I'm Interested</h2>
        </div>

        <div className='blog_data'>
            <div className='blog_img'>
                <img src={blog_data.img} alt="" />
            </div>

            <div className='blog_head'>
                <h2>What is {blog_data.title}</h2>
                <p>{blog_data.def}</p>
            </div>
            <div className='blog_head'>
                <h2>Why we use {blog_data.title}</h2>
                <p>{blog_data.why_we_use}</p>
            </div>
        </div>
        
        
    </div>
  )
}

export default BlogData